import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StorybookModule } from '@app/storybook/storybook.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DashboardModule } from '@app/dashboard/dashboard.module';
import { SearchResultsComponent } from '@pages/search/components/search-results/search-results.component';
import { SharedModule } from '@app/sharedModule/shared.module';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, StorybookModule, DashboardModule, SharedModule],
  declarations: [SearchResultsComponent],
  exports: [],
})
export class SearchModule {}
